import React, { useEffect, useState } from 'react';

import {
    Box,
    DialogContent,
    DialogActions,
    Button,
    TextField,

} from '@mui/material';
import koLocale from 'date-fns/locale/ko';
import DateAdapter from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import BootstrapDialog, { BootstrapDialogTitle } from '../../common/dialog/BootstrapDialog';


const CounselFormDialog = ({ type, open, handleClose, formik }) => {

    const [attrVal3, setAttrVal3] = useState(new Date());

    useEffect(() => {
        if (formik.values?.attrVal3 === '' || formik.values?.attrVal3 === null) {
            setAttrVal3(new Date());
            formik.setFieldValue('attrVal3', new Date());
        }
    }, [formik.values?.attrVal3])


    const onChangeDate = (newValue, name) => {
        formik.setFieldValue(name, newValue);
    };



    return (
        <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="dialog-title"
            open={open}
            fullWidth={true}
            maxWidth="sm"
        >
            <BootstrapDialogTitle id="dialog-title" onClose={handleClose}>
                개인면담일지 {type === 'edit' ? '수정' : '추가'}
            </BootstrapDialogTitle>
            <Box
                component="form"
                sx={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    flexDirection: 'column',
                }}
                noValidate
                autoComplete="off"
                onSubmit={formik.handleSubmit}
            >
                <DialogContent dividers>
                    <TextField
                        margin="normal"
                        variant="outlined"
                        fullWidth
                        id="attrVal1"
                        name="attrVal1"
                        label="종류"
                        value={formik.values.attrVal1}
                        onChange={formik.handleChange}
                        error={formik.touched.attrVal1 && Boolean(formik.errors.attrVal1)}
                        helperText={formik.touched.attrVal1 && formik.errors.attrVal1}
                    />
                    <LocalizationProvider
                        dateAdapter={DateAdapter}
                        locale={koLocale}
                    >
                        <DatePicker
                            label="등록일자"
                            inputFormat={'yyyy-MM-dd'}
                            mask={'____-__-__'}
                            id="attrVal3"
                            name="attrVal3"
                            value={attrVal3}
                            onChange={(newValue) => {
                                setAttrVal3(newValue);
                                onChangeDate(newValue, 'attrVal3');
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    margin="normal"
                                    variant="outlined"
                                    required
                                    fullWidth
                                    error={
                                        formik.touched.attrVal3 &&
                                        Boolean(formik.errors.attrVal3)
                                    }
                                    helperText={
                                        formik.touched.attrVal3 && formik.errors.attrVal3
                                    }
                                />
                            )}
                        />
                    </LocalizationProvider>
                    <TextField
                        margin="normal"
                        variant="outlined"
                        fullWidth
                        id="attrVal2"
                        name="attrVal2"
                        label="면담내용"
                        multiline
                        rows={4}
                        value={formik.values.attrVal2}
                        onChange={formik.handleChange}
                        error={formik.touched.attrVal2 && Boolean(formik.errors.attrVal2)}
                        helperText={formik.touched.attrVal2 && formik.errors.attrVal2}
                    />
                </DialogContent>
                <DialogActions >
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            disabled={formik.isSubmitting}
                        >
                            Save
                        </Button>
                    </Box>
                </DialogActions>
            </Box>
        </BootstrapDialog>
    )
}

export default CounselFormDialog